export default __webpack_public_path__ + "6611dbe571f0a4de0b9eb38e17fdbc81.svg";